import { DriverHeader } from './DriverHeader';
import { DriverFooter } from './DriverFooter';
import clsx from 'clsx';
import styles from './styles.module.scss';
import { WebSocketClientWrapper } from 'contexts/webSocketClient';
import { getAccessToken } from 'functions/localStorage';
import { useMemo } from 'react';

type IProps = {
  children: JSX.Element;
  hideLogo?: boolean;
  whiteBackground?: boolean;
};

export const DriverLayout = ({
  children,
  hideLogo,
  whiteBackground,
}: IProps) => {
  const token = useMemo(() => getAccessToken(), []);

  return (
    <WebSocketClientWrapper sessionToken={token}>
      <div
        className={clsx(styles.root, {
          [styles.withLogoHidden]: hideLogo,
          [styles.whiteBackground]: whiteBackground,
        })}
      >
        {!hideLogo && <DriverHeader />}
        <main>{children}</main>
        <DriverFooter />
      </div>
    </WebSocketClientWrapper>
  );
};
